export const readByKeys = (source, keys = [], fallback = null) => {
  if (!source || typeof source !== 'object') return fallback

  for (const key of keys) {
    const value = source[key]
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return value
    }
  }

  return fallback
}

export const pickValue = (source, snakeKey, camelKey, fallback = null) => {
  return readByKeys(source, [snakeKey, camelKey], fallback)
}

export const normalizeArray = (value) => {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.data)) return value.data
  if (Array.isArray(value?.items)) return value.items
  if (Array.isArray(value?.products)) return value.products
  if (Array.isArray(value?.users)) return value.users
  if (Array.isArray(value?.roles)) return value.roles
  return []
}

export const toSafeText = (value, fallback = '-') => {
  if (value === null || value === undefined) return fallback

  if (typeof value === 'string') {
    const normalized = value.trim()
    return normalized !== '' ? normalized : fallback
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }

  if (Array.isArray(value)) {
    const normalized = value
      .map((entry) => toSafeText(entry, ''))
      .filter((entry) => entry && entry !== '-')
    return normalized.length > 0 ? normalized.join(', ') : fallback
  }

  if (typeof value === 'object') {
    const preferred =
      value.name ||
      value.label ||
      value.title ||
      value.description ||
      value.email ||
      value.id

    if (preferred !== undefined && preferred !== null) {
      return toSafeText(preferred, fallback)
    }

    try {
      const serialized = JSON.stringify(value)
      return serialized !== '{}' ? serialized : fallback
    } catch (error) {
      return fallback
    }
  }

  return fallback
}
